import React, { ReactElement, useMemo } from 'react';

import classNames from 'classnames';
import { deepFind } from 'react-children-utilities';

import { FORM_FIELD_CLASS } from '../../utils/constants';
import Checkbox from '../Checkbox/Checkbox';
import RadioButton from '../RadioButton/RadioButton';
import Label from './components/Label/Label';
import * as Styled from './FormField.styles';
import { IFormFieldProps } from './FormField.types';

const FormField = ({
  className = '',
  id = '',
  size = 'medium',
  label = '',
  description,
  message = '',
  messagePosition = 'left',
  children,
  state = 'default',
  icon,
  mandatory = false,
  ...rest
}: IFormFieldProps): ReactElement => {
  const hasCheckbox = useMemo(
    () =>
      deepFind(
        children,
        (child) => (child as ReactElement)?.type === Checkbox || (child as ReactElement)?.type === RadioButton,
      ),
    [children],
  );

  const wrapper = (
    <>
      <Label size={size} icon={icon} id={id} label={label} description={description} mandatory={mandatory} />
      {children}
    </>
  );

  return (
    <Styled.FormField className={classNames(FORM_FIELD_CLASS, className)} {...rest}>
      {hasCheckbox ? <fieldset>{wrapper}</fieldset> : wrapper}
      {message && (
        <Styled.Message size={size} position={messagePosition} state={state}>
          {message}
        </Styled.Message>
      )}
    </Styled.FormField>
  );
};

export default FormField;
